import * as Scrivito from "scrivito";

export const TabItemWidget = Scrivito.provideWidgetClass("TabItemWidget", {
  onlyInside: "TabWidget",
  attributes: {
    headline: "string",
    content: "widgetlist",
  },
});
